import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { packagingTypeIcons } from '@/common/constants'
import { packagingTypeLabels } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/Packaging/PackagingConfiguration/constants'

import * as Styles from './styles'

const PackagingTypeSelector = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()

  const typeMenuItems = Object.entries(packagingTypeLabels).map(([key, label]) => {
    const Icon = packagingTypeIcons[key]
    return {
      label: (
        <Styles.MenuItemContent>
          <Icon size={20} />
          {t(label)}
        </Styles.MenuItemContent>
      ),
      value: key,
    }
  })

  return (
    <ComboBox
      label={t('Tipo de paquete')}
      menuItems={typeMenuItems}
      value={value}
      handleChange={e => onChange(e.target.value)}
      disabled={disabled}
      fullWidth
    />
  )
}

export default PackagingTypeSelector
